import { convexQuery, useConvexMutation } from "@convex-dev/react-query";
import { useMutation, useQuery } from "@tanstack/react-query";

import { Button } from "@/components/ui/button";
import { api } from "~/convex/_generated/api";
import { createFileRoute } from "@tanstack/react-router";
import { useAccount } from "@/state/useAccount";

export const Route = createFileRoute(
  "/_app/_auth/dashboard/_layout/settings/invites",
)({
  component: InvitesSettings,
  beforeLoad: () => ({
    title: "Invites",
    headerTitle: "Pending Invites",
    headerDescription: "Manage your pending team invites.",
  }),
});

export default function InvitesSettings() {
  const { appId } = useAccount();

  const { data: invites } = useQuery(
    convexQuery(api.invites.getAppFounderInvites, { appId }),
  );

  const { mutateAsync: acceptOrRejectInvite, isPending: isLoading } =
    useMutation({
      mutationFn: useConvexMutation(api.invites.acceptOrRejectAppFounderInvite),
    });

  if (!appId) {
    return null;
  }

  const pendingInvites =
    invites?.filter((invite) => invite.status === "pending") || [];

  if (pendingInvites.length === 0) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <p className="text-sm text-primary/60">No pending invites</p>
      </div>
    );
  }

  return (
    <div className="flex h-full w-full flex-col gap-6">
      <div className="flex w-full flex-col items-start rounded-lg border border-border bg-card">
        <div className="flex flex-col gap-2 p-6">
          <h2 className="text-xl font-medium text-primary">Pending Invites</h2>
          <div className="mt-4 space-y-4">
            {pendingInvites.map((invite) => (
              <div
                key={invite._id}
                className="flex items-center justify-between rounded-lg border border-border p-4"
              >
                <div className="flex flex-col">
                  <span className="text-sm text-primary/60">
                    {invite.inviteeEmail}
                  </span>
                </div>
                <div className="flex gap-2">
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() =>
                      acceptOrRejectInvite({
                        inviteId: invite._id,
                        status: "rejected",
                      })
                    }
                    disabled={isLoading}
                  >
                    Reject
                  </Button>
                  <Button
                    size="sm"
                    onClick={() =>
                      acceptOrRejectInvite({
                        inviteId: invite._id,
                        status: "accepted",
                      })
                    }
                    disabled={isLoading}
                  >
                    Accept
                  </Button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
